module.exports = __webpack_public_path__ + "396da1e1a6b5dba915365cb153f4d298.svg";